/**
 * Maestro Flavor Drawer JavaScript
 * Place this in: assets/maestro-flavor-drawer.js
 */

(function() {
  'use strict';

  // Elements
  const openBtn = document.getElementById('maestroOpenDrawerBtn');
  const closeBtn = document.getElementById('maestroCloseBtn');
  const overlay = document.getElementById('maestroDrawerOverlay');
  const drawer = document.getElementById('maestroFlavorDrawer');
  const handle = document.getElementById('maestroDrawerHandle');

  // State
  let startY = 0;
  let currentY = 0;
  let isDragging = false;

  /**
   * Open the drawer
   */
  function openDrawer() {
    if (!drawer || !overlay) return;
    
    overlay.classList.add('active');
    drawer.classList.add('active');
    document.body.classList.add('maestro-drawer-open');
    
    // Fire custom event
    document.dispatchEvent(new CustomEvent('maestro:drawer:opened'));
    
    // Analytics (if you use GA or similar)
    if (typeof gtag !== 'undefined') {
      gtag('event', 'flavor_drawer_opened', {
        event_category: 'engagement',
        event_label: 'Flavor Drawer'
      });
    }
  }

  /**
   * Close the drawer
   */
  function closeDrawer() {
    if (!drawer || !overlay) return;
    
    overlay.classList.remove('active');
    drawer.classList.remove('active');
    document.body.classList.remove('maestro-drawer-open');
    
    // Fire custom event
    document.dispatchEvent(new CustomEvent('maestro:drawer:closed'));
  }

  /**
   * Navigate to flavor product page
   */
  window.maestroSelectFlavor = function(url) {
    // Add loading state
    drawer.style.opacity = '0.7';
    
    // Analytics
    if (typeof gtag !== 'undefined') {
      gtag('event', 'flavor_selected', {
        event_category: 'engagement',
        event_label: url
      });
    }
    
    // Navigate
    window.location.href = url;
  };

  /**
   * Handle touch start for swipe-to-close
   */
  function handleTouchStart(e) {
    if (!handle.contains(e.target)) return;
    
    startY = e.touches[0].clientY;
    isDragging = true;
    drawer.style.transition = 'none';
  }

  /**
   * Handle touch move for swipe-to-close
   */
  function handleTouchMove(e) {
    if (!isDragging) return;
    
    currentY = e.touches[0].clientY;
    const diff = currentY - startY;
    
    // Only allow dragging down
    if (diff > 0) {
      e.preventDefault();
      drawer.style.transform = `translateY(${diff}px)`;
    }
  }

  /**
   * Handle touch end for swipe-to-close
   */
  function handleTouchEnd(e) {
    if (!isDragging) return;
    
    isDragging = false;
    drawer.style.transition = '';
    
    const diff = e.changedTouches[0].clientY - startY;
    
    // Close if dragged down more than 100px
    if (diff > 100) {
      closeDrawer();
    } else {
      // Reset position
      drawer.style.transform = '';
    }
  }

  /**
   * Handle escape key
   */
  function handleKeydown(e) {
    if (e.key === 'Escape' && drawer.classList.contains('active')) {
      closeDrawer();
    }
  }

  /**
   * Initialize event listeners
   */
  function init() {
    if (!drawer || !overlay) {
      console.warn('Maestro Flavor Drawer: Elements not found');
      return;
    }

    // Open button
    if (openBtn) {
      openBtn.addEventListener('click', openDrawer);
    }

    // Close button
    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }

    // Overlay click
    overlay.addEventListener('click', closeDrawer);

    // Escape key
    document.addEventListener('keydown', handleKeydown);

    // Touch events for swipe-to-close (mobile)
    if (handle) {
      drawer.addEventListener('touchstart', handleTouchStart, { passive: false });
      drawer.addEventListener('touchmove', handleTouchMove, { passive: false });
      drawer.addEventListener('touchend', handleTouchEnd);
    }

    // Prevent clicks inside drawer from closing it
    drawer.addEventListener('click', function(e) {
      e.stopPropagation();
    });

    console.log('Maestro Flavor Drawer initialized');
  }

  /**
   * Auto-open drawer on page load (optional)
   * Uncomment if you want the drawer to open automatically
   */
  // function autoOpenDrawer() {
  //   // Only auto-open once per session
  //   if (!sessionStorage.getItem('maestro_drawer_seen')) {
  //     setTimeout(() => {
  //       openDrawer();
  //       sessionStorage.setItem('maestro_drawer_seen', 'true');
  //     }, 1000);
  //   }
  // }

  /**
   * Initialize when DOM is ready
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose functions globally if needed
  window.maestroFlavorDrawer = {
    open: openDrawer,
    close: closeDrawer
  };

})();
